import {ScrollView, View} from 'react-native'
import {msg} from '@lingui/macro'
import {useLingui} from '@lingui/react'

import {atoms as a, useTheme} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import {Text} from '#/components/Typography'

export function TellusTVShelf({
  title,
  itemsCount,
  onPressSeeAll,
  children,
}: {
  title: string
  itemsCount: number
  onPressSeeAll?: () => void
  children: React.ReactNode
}) {
  const t = useTheme()
  const {_} = useLingui()

  if (!itemsCount) {
    return null
  }

  return (
    <View style={[a.gap_sm]}>
      <View style={[a.flex_row, a.align_center, a.justify_between]}>
        <Text style={[a.text_lg, a.font_bold]}>{title}</Text>
        {onPressSeeAll ? (
          <Button
            label={_(msg`See all`)}
            onPress={onPressSeeAll}
            variant="ghost"
            color="secondary"
            size="small">
            <ButtonText style={[t.atoms.text_contrast_medium]}>
              {_(msg`See all`)}
            </ButtonText>
          </Button>
        ) : null}
      </View>
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={[a.gap_md, a.pr_lg]}>
        {children}
      </ScrollView>
    </View>
  )
}
